import { pluralizeWord } from '@doveit/hammer';
import { IndividualRank } from '../../../providers/api/dtos';
import { currentYear } from '../../../utils/time/time';

export function getRankDetails(individualRank: IndividualRank) {
  return individualRank.topX && `Ti ${pluralizeWord('manc', 'a', 'ano', individualRank.topX.sales)} ${individualRank.topX.sales} ${pluralizeWord('vendit', 'a', 'e', individualRank.topX.sales)} per entrare nella top ${individualRank.topX.topRankingType}`;
}

export function getRankTitle(rank: IndividualRank): string {
  const { rankType, rank: position, totalAgents } = rank;

  const thresholds: number[] = rankType === 'AGENT' ? [3, 10, 20] : [3, 10];
  const topX = thresholds.find((x) => position <= x);
  const suffix = rankType === 'ROOKIE' ? ' rookie' : '';

  if (topX) {
    return `Sei nella **top ${topX}** per numero di vendite nel ${currentYear()}, su ${totalAgents} agenti${suffix} di Dove.it.`;
  }

  return `Sei **#${position}** per numero di vendite nel ${currentYear()}, su ${totalAgents} agenti${suffix} di Dove.it.`;
}
